import styled from "styled-components";
import { ids } from "@icarros/theme-react";
const { foundation_layout, size } = ids || {};
export const StyledMenuGrid = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  background: transparent;
  gap: ${size.general.ids_size_general_16x};

  @media (max-width: ${foundation_layout.breakpoint.idl_layout_breakpoint_xs}) {
    gap: ${size.general.ids_size_general_12x};
  }
`;
//# sourceMappingURL=MenuGrid.style.js.map